import React, { useEffect, useState } from "react";
import { Layout, Menu } from "antd";
import {
  HomeOutlined,
  IdcardOutlined,
  ReadOutlined,
  UserOutlined
} from "@ant-design/icons";
import { Link } from "react-router-dom";

const { Sider } = Layout;

interface SidebarProps {
  collapsed: boolean;
  onCollapse: (collapsed: boolean) => void;
  onChangeTitle: (title: string) => void
}

const Sidebar: React.FC<SidebarProps> = ({ collapsed, onCollapse ,onChangeTitle}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 900);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  if (isMobile) return null;

  return (
    <Sider
      collapsible
      collapsed={collapsed}
      onCollapse={onCollapse}
      theme="dark"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        height: "100vh",
        zIndex: 100,
      }}
    >
      <Menu theme="dark" mode="inline">
        <Menu.Item
          key="1"
          icon={<HomeOutlined />}
          onClick={() => onChangeTitle("Giải đấu")}
        >
          <Link to="/tournament">Giải đấu</Link>
        </Menu.Item>
        <Menu.Item
          key="2"
          icon={<UserOutlined />}
          onClick={() => onChangeTitle("Quản lý người dùng")}
        >
          <Link to="/user-management">Quản lý người dùng</Link>
        </Menu.Item>
        <Menu.Item
          key="3"
          icon={<IdcardOutlined />}
          onClick={() => onChangeTitle("Quản lý câu lạc bộ")}
        >
          <Link to="/club-management">Quản lý câu lạc bộ</Link>
        </Menu.Item>
        <Menu.Item
          key="4"
          icon={<ReadOutlined />}
          onClick={() => onChangeTitle("Quản lý Blog")}
        >
          <Link to="/blog-management">Quản lý Blog</Link>
        </Menu.Item>
        <Menu.Item
          key="5"
          icon={<ReadOutlined />}
          onClick={() => onChangeTitle("Quản lý bảng vinh danh")}
        >
          <Link to="/leader-board-management">Quản lý vinh danh</Link>
        </Menu.Item>
        <Menu.Item
          key="6"
          icon={<ReadOutlined />}
          onClick={() => onChangeTitle("Quản lý huấn luyện viên")}
        >
          <Link to="/coach-management">Quản lý HLV</Link>
        </Menu.Item>
        <Menu.Item
          key="7"
          icon={<ReadOutlined />}
          onClick={() => onChangeTitle("Quản lý nhật ký")}
        >
          <Link to="/auditlog-management">Quản lý nhật ký</Link>
        </Menu.Item>
      </Menu>
    </Sider>
  );
};

export default Sidebar;
